import * as $ from 'jquery';
import {Notif} from "@/js/global/components/Notif";

export const forgotPasswordAjax = ()=>{
    $('#forgot_password_form').on('submit', async function (e) {

        e.preventDefault();

        const $form = $(this);
        $form.find(".form-input").removeClass("border-error");
        const $btn = $('.reset-password');
        $btn.attr('disabled', true);

        let valid = true;

        const pk = localizedScript.pk;
        const $email = $("#reset_email");
        const email = $email.val();
        const emailError = $('#reset_email_error');
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            emailError.text('Not valid email');
            emailError.removeClass("hidden");
            $email.classList.add("border-error");
            valid = false;
        } else {
            valid = true;
        }

        if (!valid) return;
        const action = localizedScript.forgot_password_action;
        const token = await grecaptcha.execute(pk, {action: action});

        $.ajax({
            url: localizedScript.ajax_url,
            type: 'POST',
            data: {
                action: action,
                nonce: localizedScript.forgot_password_nonce,
                email: email,
                recaptcha_token:token
            },
            success: function (response) {
                console.log(response);
                if(response.success){
                    Notif.show('success',response.data.message);
                    $btn.attr('disabled', false);
                    $form.addClass('hidden');
                    $('#sent_email_message').text(response.data.message);
                    $('#sent_email_to').text(response.data.email);
                    $('#resend_email_form').removeClass('hidden');
                    $('#resend_email').val(response.data.email);
                }else{
                    Notif.show('error',response.data.message);
                    $btn.attr('disabled', false);
                }
            }
        });
    });

}